import React from "react";
import { useNavigate } from "react-router-dom";
import {
    FolderOpen,
    ClipboardList,
    Map,
    Layers3,
    Milestone,
    Database,
} from "lucide-react";
import { PATHNAME } from "../../../pathname";

export const MASTER_TABS = [
    { id: "internalOrderMaster", name: "Internal Order Master", icon: FolderOpen },
    { id: "orderAllocationUpdation", name: "Order Allocation Updation", icon: ClipboardList },
    { id: "ioUnitMapping", name: "IO Unit Mapping", icon: Map },
    { id: "ioAllocation", name: "IO Allocation", icon: Layers3 },
    { id: "projectMilestone", name: "Project Milestone", icon: Milestone },
    { id: "masterUploads", name: "Customer", icon: Database },
];

const MastersTabBar = ({ activeId, onSelect }) => {
    const navigate = useNavigate();

    const handleClick = (tabId) => {
        if (onSelect) {
            onSelect(tabId);
        } else {
            navigate(PATHNAME.ADMIN_MASTERS, { state: { tab: tabId } });
        }
    };

    return (
        <div className="mb-2 border-b border-slate-200">
            <div className="flex gap-1 overflow-x-auto">

                {MASTER_TABS.map((tab) => {

                    const Icon = tab.icon;
                    const active = activeId === tab.id;

                    return (
                        <button
                            key={tab.id}
                            onClick={() => handleClick(tab.id)}
                            className={`flex items-center gap-2 px-4 py-2 border-b-2 text-sm font-medium transition

                            ${active
                                    ? "border-blue-600 text-blue-600 bg-blue-50 rounded-t-lg"
                                    : "border-transparent text-slate-500 hover:text-slate-700"
                                }
                        `}
                        >
                            <Icon size={16} />
                            {tab.name}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default MastersTabBar;
